import * as types from '../constants/idpAdminActions';
import * as oidcConstants from '../constants/oidcConstants';
import * as messages from '../shared/messages';

export const SUBMIT_STATUS = {
  IDLE: 'IDLE',
  SUBMITTING: 'SUBMITTING',
  SAVED: 'SAVED',
};

const initialState = {
  errorMsg: null,
  nameErrorMsg: null,
  submitStatus: SUBMIT_STATUS.IDLE,
  credentialsInProgress: false,
  applicationName: '',
  oidcRedirectUris: oidcConstants.DEFAULT_REDIRECT_URIS,
  clientId: '',
  clientSecret: '',
  signature: '',
  isPublicClient: false,
};

const addOidcFailMessage = (failure) => {
  switch (failure.code) {
    case oidcConstants.OIDC_CLIENT_ID_ALREADY_IN_USE:
    case oidcConstants.OIDC_CLIENT_ID_OR_CLIENT_SECRET_IS_NOT_VALID:
      return messages.OIDC_CLIENT_CREDENTIALS_REGENERATED;
    case oidcConstants.CLOUD_SERVER_FAILURE:
      return messages.OIDC_CLOUD_SERVER_FAILURE;
    case oidcConstants.REQUEST_INSUFFICIENT_DATA:
      return messages.OIDC_REQUEST_INSUFFICIENT_DATA;
    default:
      return failure.status !== 400 && failure.reason ? failure.reason : messages.GENERIC_ERROR;
  }
};

export default function sp(state = initialState, action = {}) {
  switch (action.type) {
    case types.GENERATE_OIDC_CLIENT_CREDENTIALS_START:
      return {
        ...state,
        credentialsInProgress: true
      };
    case types.GENERATE_OIDC_CLIENT_CREDENTIALS_SUCCESS:
      return {
        ...state,
        credentialsInProgress: false,
        clientId: action.response.clientId,
        clientSecret: action.response.clientSecret,
        signature: action.response.signature,
      };
    case types.GENERATE_OIDC_CLIENT_CREDENTIALS_FAIL:
      return {
        ...state,
        credentialsInProgress: false,
        clientId: '',
        clientSecret: '',
        signature: '',
        errorMsg: messages.GENERIC_ERROR
      };
    case types.ADD_OIDC_APP_START:
      return {
        ...state,
        errorMsg: null,
        nameErrorMsg: null,
        submitStatus: SUBMIT_STATUS.SUBMITTING
      };
    case types.ADD_OIDC_APP_SUCCESS:
      return {
        ...state,
        submitStatus: SUBMIT_STATUS.SAVED
      };
    case types.ADD_OIDC_APP_FAIL:
      return action.failure.code === oidcConstants.SBA_APP_NAME_ALREADY_IN_USE
          ? {
            ...state,
            submitStatus: SUBMIT_STATUS.IDLE,
            nameErrorMsg: state.applicationName.trim() + messages.APP_NAME_IS_DUPLICATED
          }
          : {
            ...state,
            submitStatus: SUBMIT_STATUS.IDLE,
            errorMsg: addOidcFailMessage(action.failure)
          };
    case types.DELETE_OIDC_REDIRECT_URI:
      return {
        ...state,
        oidcRedirectUris: state.oidcRedirectUris.filter(
            item => item !== action.targetOidcRedirectUri)
      };
    case types.ADD_OIDC_REDIRECT_URI:
      return {
        ...state,
        oidcRedirectUris: [...state.oidcRedirectUris, action.newOidcRedirectUri]
      };
    case types.UPDATE_OIDC_REDIRECT_URI:
      return {
        ...state,
        oidcRedirectUris: state.oidcRedirectUris.map((item, index) => {
          if (index.toString() !== action.payload.target.id.toString()) {
            return item
          }
          return {
            ...item,
            [action.payload.target.name]: action.payload.target.value.trim(),
          }
        })
      };
    case types.UPDATE_APP_NAME:
      return {
        ...state,
        nameErrorMsg: null,
        applicationName: action.payload
      };
    case types.UPDATE_IS_PUBLIC_CLIENT:
      return {
        ...state,
        isPublicClient: action.value
      };
    case types.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: action.errorMsg
      };
    case types.CLEAR_MESSAGES:
      return {
        ...state,
        errorMsg: null
      };
    default:
      return state;
  }
}
